import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTaggingInformationScreen } from '../../../../utils/Tagging';
import { sendTagging } from '../../../../store/ducks/tagging/actions';
import { Title, Button, SearchField } from '@gerdau/hefesto';
import { Container, FilterContainer } from './styles';
import NFTable from './NFTable';
import { ApplicationState } from '../../../../store';
import moment from 'moment';
import { ICustomerNFItem } from '../../../../store/ducks/download-area/types';
import { useLocation } from 'react-router-dom';

const NFTabContent: React.FC = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { screenName = '' } = getTaggingInformationScreen('download-area');
  const [searchInput, setSearchInput] = useState<string>('');
  const [nfsData, setNfsData] = useState<ICustomerNFItem[]>([]);

  const downloadAreaState = useSelector(
    (appState: ApplicationState) => appState.downloadArea
  );

  const nfsState = useSelector(
    (appState: ApplicationState) => appState.downloadArea.nfsState
  );

  const isDisabled = downloadAreaState.nfsState.loading;

  useEffect(() => {
    dispatch(
      sendTagging({
        screenName: `${screenName}:NotaFiscal`,
        page: pathname,
        event: 'page_view'
      })
    );
  }, []);

  useEffect(() => {
    setNfsData(nfsState.items);
  }, [nfsState.items]);

  const onFilter = (newSearchInputValue: string) => {
    setSearchInput(newSearchInputValue);

    const filteredItems = nfsState.items.filter(
      (item: ICustomerNFItem) =>
        item.orderNumber.includes(newSearchInputValue) ||
        item.invoiceNumber.includes(newSearchInputValue) ||
        (item.itemBillingDate &&
          moment(item.itemBillingDate, 'YYYY-MM-DD')
            .format('DD/MM/YYYY')
            .includes(newSearchInputValue))
    );

    setNfsData(filteredItems);
  };

  const onClear = () => {
    setSearchInput('');
    setNfsData(nfsState.items);
    dispatch(
      sendTagging({
        event: 'click',
        itemName: 'button:limpa_filtros',
        itemDescription: 'busccarDocumentos_notaFiscal_limparFiltros',
        filterInfo: `#codEmr:${downloadAreaState.customerId}#dtInicio:${moment(
          downloadAreaState.startDate
        ).format('YYYY_MM_DD')}#dtFim:${moment(
          downloadAreaState.endDate
        ).format('YYYY_MM_DD')}`,
        screenName
      })
    );
  };

  return (
    <>
      <Container>
        <Title level={3}>Filtros</Title>
        <FilterContainer>
          <SearchField
            data-testid="hefesto-search-field"
            label="Pesquisar"
            name="search"
            inputValue={searchInput}
            disabled={isDisabled}
            onChange={(e) => onFilter(e.target.value)}
            placeholder="Pesquise por Nº do pedido, Nº da nota fiscal ou data de emissão"
          />
          <Button
            name="limparFiltros"
            variant="none"
            onClick={onClear}
            disabled={!searchInput}
            loading={isDisabled}
          >
            Limpar filtros
          </Button>
        </FilterContainer>
      </Container>

      {!isDisabled && <NFTable data={nfsData} />}
    </>
  );
};

export default NFTabContent;
